import { Divider, Stack } from "@mantine/core";
import { Fragment } from "react";

import { NotificationItem } from "../NotificationItem";

import type { Notification } from "@/types/notification";
import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";
import type { NotificationItemProps } from "../NotificationItem";

export type NotificationListProps = {
  component?: NotificationItemProps["component"];
  items: Notification[];
  onClick?: NotificationItemProps["onClick"];
  onRead?: NotificationItemProps["onRead"];
} & MantineStyleProps;

export const NotificationList: FC<NotificationListProps> = ({
  component,
  items,
  onClick,
  onRead,
  ...props
}) => {
  // TODO: empty state

  return (
    <Stack gap={0} {...props}>
      {items.map((notification, index) => (
        <Fragment key={index}>
          {index > 0 && <Divider />}
          <NotificationItem
            key={index}
            component={component}
            {...notification}
            onClick={onClick}
            onRead={onRead}
          />
        </Fragment>
      ))}
    </Stack>
  );
};
